<template>
  <v-row class="bg-image" no-gutters>
    <v-card
      class="main-card mx-auto pa-5"
      :class="{
        'pa-5 mobile-main-card': $vuetify.breakpoint.smAndDown,
      }"
    >
      <v-card-title class="pa-0">
        <span class="font-weight-bold main-heading"> Login here </span>
      </v-card-title>
      <v-card-text class="pa-0 mt-6">
        <v-form class="mt-10" ref="form" lazy-validation @submit.prevent="onSubmit">
          <v-text-field
            v-model="email"
            class="login-field-button"
            outlined
            :rules="emailRules"
            placeholder="Enter Your Email"
            color="#434343"
            name="email"
            required
            :prepend-inner-icon="'mdi-email'"
          ></v-text-field>
          <v-text-field
            class="login-field-button"
            v-model="password"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :rules="passwordRules"
            :type="show ? 'text' : 'password'"
            name="password"
            placeholder="Enter Your Password"
            color="#434343"
            hint="At least 8 characters"
            :prepend-inner-icon="'mdi-lock'"
            counter
            outlined
            required
            @click:append="show = !show"
          ></v-text-field>
          <div class="text-center">
            <v-btn
              class="login-btn" block
              type="submit"
              x-large
              :loading="loader"
              :disabled="loader"
            >
              Login
            </v-btn>
          </div>
          <v-row class="mt-2">
            <v-col cols="">
              <a class="appGray--text" @click="register()"
                  ><span class="caption"> Create an account</span></a>
            </v-col>
            <v-col cols="">
              <p class="text-right"> <a @click="forgotPassword()" class="appBlack--text caption"
                >Forgot Password?</a
              ></p>
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
    </v-card>
    <v-card-text >
      <v-row class="position-relative">
        <v-col offset-lg="2" offset-md="3" offset-sm="4">
          <p class="text-left mt-14 ml-5 pt-16 caption footer position-absolute">
            <a class="appGray--text">Privacy &nbsp; | &nbsp; Terms & Condition</a>
          </p>
        </v-col>
      </v-row>
    </v-card-text>
  </v-row>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { showSnackbar } from "../utils/GlobalActions";
export default {
  name: "SignIn",
  components: {},
  data() {
    return {
      linkExpired: false,
      index: 6,
      loader: false,
      show: false,
      password: "",
      email: "",
      snackbarSuccess: false,
      successText: "",
      snackbarError: false,
      errorText: "",
      passwordRules: [
        (v) => !!v || "Required",
        (v) => v.length >= 8 || "Password must be 8 characters long",
      ],
      emailRules: [
        (v) => !!v || "Required",
        (v) => /.+@.+/.test(v) || "E-mail must be valid",
      ],
    };
  },
  computed: {
    ...mapGetters([
      "getUserId",
      "getFormId",
      "getCorporateID",
      "getPrimaryID",
      "getTechnicalID",
      "getFinancialID",
      "getBusinessPrimaryID",
      "getTransactionID",
      "getWebAppID",
      "getWebContentID",
    ]),
  },
  mounted() {
    /* Check if route url have token and email */
    if (this.$route.query.token && this.$route.query.email) {
      this.validateResetPasswordToken();
    }
  },

  methods: {
    async onSubmit() {
        this.loader= true;
       if(this.$refs.form.validate()){
          axios
          .post("/login", {
            email: this.email,
            password: this.password,
          })
          .then((response) => {
            localStorage.setItem("token", response.data.token);
            localStorage.setItem(
              "is_onboarded",
              response.data.userFormData[0].is_onboarded
            );
            this.loader = false;
            this.$store.dispatch("updateUser", response.data);
            if (response.data.userFormData[0].is_onboarded == 1) {
              this.updateIndex(7);
            }
            this.$router.push({ path: "/application" });
          })
          .catch((error) => {
            if(error.response.status==401){
            showSnackbar("Error!", "Invalid email or password","error");
            this.loader = false;
            }
            if (error) {
              this.errorText = "Invalid Username or Password";
              this.snackbarError = true;
              this.loader = false;
            }
          });
       }
       else{
         this.loader = false;
         showSnackbar("Error!", "All fields are required","error");
       }
    },

    updateIndex(index) {
      this.$store.dispatch("updateIndex", index);
    },
    forgotPassword() {
      this.$router.push({ name: "forgotPassword" });
    },
    register() {
      this.$router.push({ path: "/signup" });
    },

    /* This method will validate token and email from url,
    and send that email and token in request body to check if link is expired or not*/
    validateResetPasswordToken() {
      // this.pageLoad = true;
      axios
        .post(
          "/check_link_expiry?token=" +
            this.$route.query.token +
            "&email=" +
            this.$route.query.email
        )
        .then((res) => {
          // this.pageLoad = false;
          this.$router.push({ name: "resetPassword" });
        })
        .catch((err) => {
          // this.pageLoad = false;
          if (err.response.data.msg) {
            this.linkExpired = true;
            // this.errorText = "Link has been expired, please try again!";
            // this.snackbarError = true;
          }
        });
    },
  },
};
</script>
<style>
.login-field-button .v-icon {
  color: #8692a6 !important;
  margin-bottom: 10px;
}
.mdi-eye-off {
  margin-bottom: -6px !important; 
}
.mdi-eye-off {
  margin-bottom: -6px !important; 
}
</style>
<style scoped>
.bg-image {
  background: url('../assets/login-bg-web.svg');
  height: 100%;
  background-size: cover;
}

.main-heading {
  font-size: 24px !important;
  font-weight: 600 !important;
}
.footer {
  position: relative;
  bottom: 0;
  width: 100%;
}
.input-size {
  width: 100% !important;
}

label {
  color: #161c27;
}

.check-box {
  color: aqua !important;
}
.main-card {
  width: 446px;
  height: 437px;
  margin-top: 14.5%;  
  box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
  position: relative;
  right: 24%;
}
@media only screen and (max-width: 1024px) {
  .main-card {
    width: 370px;
    height: 437px;
    margin-top: 35%;  
    position: relative;
      box-shadow: rgba(50, 50, 93, 0.25) 0px 6px 12px -2px,
    rgba(0, 0, 0, 0.3) 0px 3px 7px -3px;
    right: 0%;
  }
  .bg-image {
    background: url('../assets/login-bg.svg');
    height: 100%;
    background-size: cover;
  }
}
.pa-5 {
  padding: 50px !important;
}
.login-btn{
  height: 38px !important;
  color: white !important;
  background: #161c27 !important;
}
.v-sheet.v-card {
  border-radius: 12px; 
}
</style>
